export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/staff-pick.222793eb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};